/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Coaching_Ai_QuestionInputs */

const en_us2_coaching_ai_question = /** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Build a draft plan for ${i?.name}, from their workout history, goal and restrictions. Do not publish it: I review and approve it before it takes effect.`)
};

const pt_br2_coaching_ai_question = /** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Monte um rascunho de plano para ${i?.name}, a partir do histórico de treinos, do objetivo e das restrições. Não publique: eu reviso e aprovo antes de valer.`)
};

const pt_pt2_coaching_ai_question = /** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Monte um rascunho de plano para ${i?.name}, a partir do histórico de treinos, do objetivo e das restrições. Não publique: eu reviso e aprovo antes de valer.`)
};

/** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */
const es_419_coaching_ai_question = en_us2_coaching_ai_question;

/** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */
const fr_fr2_coaching_ai_question = en_us2_coaching_ai_question;

/** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */
const de_de2_coaching_ai_question = en_us2_coaching_ai_question;

/** @type {(inputs: Coaching_Ai_QuestionInputs) => LocalizedString} */
const it_it2_coaching_ai_question = en_us2_coaching_ai_question;

/**
* | output |
* | --- |
* | "Build a draft plan for {name}, from their workout history, goal and restrictions. Do not publish it: I review and approve it before it takes effect." |
*
* @param {Coaching_Ai_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_ai_question = /** @type {((inputs: Coaching_Ai_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Ai_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_ai_question(inputs)
	if (locale === "es-419") return es_419_coaching_ai_question(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_ai_question(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_ai_question(inputs)
	if (locale === "de-DE") return de_de2_coaching_ai_question(inputs)
	if (locale === "it-IT") return it_it2_coaching_ai_question(inputs)
	return en_us2_coaching_ai_question(inputs)
});
export { coaching_ai_question as "coaching.ai_question" }